module.exports = __webpack_public_path__ + "static/media/MediaHub_White.681f4719.png";